"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.getAxios = exports.postAxios = void 0;
var AUTH_BASE_URL = process.env.REACT_APP_AUTH_API;
var errorResponse = function (error) {
    var _a, _b, _c;
    return {
        error: true,
        errorMessage: ((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message[0]) === null || _c === void 0 ? void 0 : _c.error_code) || "Something went wrong",
        data: null
    };
};
var postAxios = function (args) { return __awaiter(void 0, void 0, void 0, function () {
    var myHeaders, raw, requestOptions, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");
                raw = JSON.stringify(args.body);
                requestOptions = {
                    method: 'POST',
                    headers: myHeaders,
                    body: raw
                };
                return [4 /*yield*/, fetch("".concat(AUTH_BASE_URL).concat(args.url), requestOptions)
                        .then(function (response) { return response.text(); })
                        .then(function (result) {
                        return JSON.parse(result);
                    })["catch"](function (error) { return console.log('error fetch', error); })];
            case 1:
                response = _a.sent();
                if (response.data, response.is_complete) {
                    return [2 /*return*/, {
                            error: false,
                            data: response.data,
                            errorMessage: null
                        }];
                }
                return [2 /*return*/, {
                        error: true,
                        errorMessage: (response.message && response.message.length > 0) ? response.message[0].error_code : 'Something went wrong',
                        data: null
                    }];
            case 2:
                error_1 = _a.sent();
                return [2 /*return*/, errorResponse(error_1)];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.postAxios = postAxios;
var getAxios = function (args) { return __awaiter(void 0, void 0, void 0, function () {
    var myHeaders, requestOptions, response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                myHeaders = new Headers();
                myHeaders.append("Authorization", "Bearer ".concat(localStorage.getItem('authToken')));
                requestOptions = {
                    method: 'GET',
                    headers: myHeaders
                };
                return [4 /*yield*/, fetch(AUTH_BASE_URL + args.url, requestOptions)
                        .then(function (response) { return response.text(); })
                        .then(function (result) {
                        console.log('fetch get', JSON.parse(result));
                        return JSON.parse(result);
                    })["catch"](function (error) { return console.log('error', error); })];
            case 1:
                response = _a.sent();
                if (response.data) {
                    return [2 /*return*/, {
                            error: false,
                            data: response.data,
                            errorMessage: null
                        }];
                }
                return [2 /*return*/, {
                        error: true,
                        errorMessage: 'Something went wrong',
                        data: null
                    }];
            case 2:
                error_2 = _a.sent();
                return [2 /*return*/, errorResponse(error_2)];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports.getAxios = getAxios;
